<template>
    <div :class="{'col-md-4': !edit, 'not-edit': !edit, 'col-md-24': edit}" ref="form">
        <div v-if="edit" class="card p-4 edit-card">
            <file-input v-model="researcher.image" label="Bild" type="image"></file-input>
            <div class="admin-info">
                Das Foto des Wissenschaftlers bitte in genügend hoher Auflösung hinterlegen. Es wird vom System
                automatisch quadratisch zugeschnitten. Es sollte auf einen einheitlichen Ausschnitt beim ganzen Team
                geachtet werden, ggf. mit einem lokalen Bildbearbeitungsprogramm nachhelfen.
            </div>
            <hr>
            <text-input v-model="researcher.name" label="Name" ref="name"/>
            <long-text-input v-model="researcher.description" label="Universität" ref="description"/>
            <div class="form-group">
                <button class="btn btn-primary" @click.prevent="save">Speichern</button>
                <button class="btn btn-secondary" @click.prevent="stopEdit">Schliessen</button>
            </div>
            <div class="admin-info">
                Beim Speichern kann es sein, dass das hochgeladene Bild verschwindet. In diesem Fall bitte das ganze Projekt speichern (Button ganz unten an der Seite) und die Seite neu laden.
            </div>
        </div>
        <div class="card" v-else>
            <img class="card-img-top"
                 v-if="researcher && researcher.image && researcher.image.urls && researcher.image.urls.preview"
                 :src="researcher.image.urls.preview">
            <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{researcher.name.text}}</h5>
                <div style="margin-top: auto;" class="d-flex justify-content-between">
                    <button @click.prevent="startEdit" class="btn btn-primary col">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button @click.prevent="$emit('delete')" class="btn btn-danger col">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default {
  components: {},
  props: ["value"],
  data() {
    return {
      edit: false,
      researcher: this.value
    };
  },
  methods: {
    save() {
      let form = new FormData();
      if (this.researcher.image && this.researcher.image.id) {
        form.append('edit_researcher[image]', this.researcher.image.id)
      } else {
        form.append('edit_researcher[image]', "")
      }
      Promise.all([
        this.$refs.name.save(),
        this.$refs.description.save(),
        // this.$refs.longDescription.save(),
        axios.post(
          "/api/" +
            store.state.language +
            "/researcher/" +
            this.researcher.id +
            "/edit",
          form
        )
      ]).then(responses => {
        this.edit = false;
        this.$emit("input", this.researcher);
      });
    },
    startEdit() {
      this.edit = true;
      this.$emit("edit");
    },
    stopEdit() {
      this.edit = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Researcher.vue